export default "__VITE_ASSET__ffd73163__"